<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customerForm.actions.schedule.title')"
    :info="info"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('general.schedule'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="text-left">
      <o-form ref="formRef">
        <o-field-group
          v-if="select"
          v-slot="{ status }"
          :label="$t('general.form')"
          :name="$t('general.form')"
          class="mb-4 block"
          rules="required"
        >
          <form-select v-model="form" :status="status" class="w-full mt-1" />
        </o-field-group>

        <div v-if="!select && form" class="mb-4 w-full p-3 border rounded-lg">
          <p class="text-gray-600 text-xs">
            {{ $t('general.form') }}
          </p>
          <p class="text-gray-800 font-semibold text-sm">
            {{ form.title }}
          </p>
        </div>

        <div class="m-2">
          <o-field-group>
            <checkbox-field v-model="prefill" :label="$t('form.prefill')" :info="$t('form.prefillInfo')" label-class="text-sm w-full ml-2 opacity-90 flex justify-between items-center" />
          </o-field-group>
        </div>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import FormSelect from '@/components/form/elements/Select.vue'
import { CheckboxField } from '@/components/fields'


interface Props {
  customer: any
  reservation?: any
  offset?: number
  portal?: string
  loading?: boolean
  select?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
  offset: 0,
  portal: undefined,
  loading: false,
  select: true,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const formRef = ref<any>()
const form = ref<any>(null)
const prefill = ref(true)

const info = computed(() => {
  return $i18n.t('components.customerForm.actions.schedule.info', { name: props.customer.displayName })
})

const open = (formArg: any = null) => {
  form.value = formArg
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  const { customer, reservation, offset } = props

  const options = {
    customer,
    reservation,
    form: form.value,
    prefill: prefill.value,
    offset,
  }

  try {
    const success = await $api.customerForm.scheduleForm({
      formId: form.value?.idForm,
      customerId: customer?.idCustomer,
      reservationId: reservation?.idReservation,
      prefill: prefill.value,
      offset,
    })

    if (success) {
      emit('success')
      $notification.toast({
        title: $i18n.t('components.customerForm.actions.schedule.success'),
        variant: 'success',
      })

      return true
    }
  } catch (e: any) {
    emit('error')
    $notification.toast({ errors: e?.errors })
  }
}

defineExpose({ open })
</script>
